/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgConfirm.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { PLATFORM } from "../../config";

class OrgConfirm extends Component {
  render() {
    const languageObj = this.props.languageObj;

    return (
      <div className="OrgConfirm-view">
        <div className="OrgConfirm-header">
          {/* Conditionally render logo based on platform */}
          <div
            className={
              PLATFORM === "plug"
                ? "OrgConfirm-PlugLogo"
                : "OrgConfirm-CheckPlusLogo"
            }
          />
          <div className="OrgConfirm-bigHeading">Action Required</div>
          <div className="OrgConfirm-subheading">
            Please check your email and verify your account.
          </div>
        </div>

        <div className="OrgConfirm-centerContainer">
          <div className="OrgConfirm-prompt">
            <div className="OrgConfirm-documentContainer">
              <div className="OrgConfirm-documentIcn"></div>
              <div className="OrgConfirm-heading">{languageObj.text1}</div>
              <div className="OrgConfirm-text">{languageObj.text2}</div>
            </div>
            <div className="OrgConfirm-completedIcn" />
          </div>

          <div className="OrgConfirm-spaceInBetween"></div>

          <div className="OrgConfirm-prompt">
            <div className="OrgConfirm-loginContainer">
              <div className="OrgConfirm-mailVerifyIcn"></div>
              <div className="OrgConfirm-heading">{languageObj.text3}</div>
              <div className="OrgConfirm-text">
                {languageObj.emailText[0]} {languageObj.emailText[1]}
              </div>
              <Link to="/OrgLogin">
                <div className="OrgConfirm-doneBtn">
                  <div className="OrgConfirm-doneText">
                    {languageObj.doneBtn}
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
OrgConfirm.propTypes = {
  languageObj: PropTypes.object,
};

export default OrgConfirm;
